import { frontendURL } from '../../../helper/URLHelper';
import account from './account/account.routes';
import agent from './agents/agent.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import bulkActions from './bulk-actions/bulk-actions.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import campaigns from './campaigns/campaigns.routes';
import canned from './canned/canned.routes';
import agentBotManagement from './agentBotManagement/agentbotmanagement.routes';
import inbox from './inbox/inbox.routes';
import integrationapps from './integrationapps/integrations.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import profile from './profile/profile.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import teams from './teams/teams.routes';
import docs from './docs/doc.routes';
import feedback from './feedback/feedback.routes';
import closingreasons from './closingreasons/closing.routes';
import cadencias from './cadencias/cadencia.routes';
import events from './events/events.routes';
import virtualAssistent from './virtualAssistent/virtual_assistent.router';
import opportunityPipelines from './opportunityPipelines/opportunityPipelines.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      roles: [
        'administrator',
        'supervisor',
        'team_supervisor',
        'agent',
        'seller',
        'assistant',
        'analyzer',
      ],
      redirect: () => {
        if (store.getters.getCurrentRole === 'administrator') {
          return frontendURL('accounts/:accountId/settings/general');
        }
        if (store.getters.getCurrentRole === 'supervisor') {
          return frontendURL('accounts/:accountId/settings/agents');
        }
        if (store.getters.getCurrentRole === 'team_supervisor') {
          return frontendURL('accounts/:accountId/settings/teams/list');
        }
        return frontendURL('accounts/:accountId/settings/macros');
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      redirect: () => {
        return frontendURL('accounts/:accountId/settings/applications');
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations/*'),
      redirect: to => {
        return frontendURL(
          `accounts/:accountId/settings/applications/${to.params.pathMatch}`
        );
      },
    },
    ...account.routes,
    ...agent.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...bulkActions.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...campaigns.routes,
    ...canned.routes,
    ...agentBotManagement.routes,
    ...inbox.routes,
    ...integrationapps.routes,
    ...integrations.routes,
    ...labels.routes,
    ...macros.routes,
    ...profile.routes,
    ...reports.routes,
    ...teams.routes,
    ...docs.routes,
    ...feedback.routes,
    ...closingreasons.routes,
    ...cadencias.routes,
    ...events.routes,
    ...virtualAssistent.routes,
    ...opportunityPipelines.routes,
  ],
};
